import type { PlayerStatusChangeHandler } from '../model/useGameStreamPlayer';
import { useGameStreamPlayer } from '../model/useGameStreamPlayer';

type GameStreamVideoProps = {
  onStatusChange?: PlayerStatusChangeHandler;
  muted: boolean;
  streamName: string;
  whepUrl: string | undefined;
};

export function GameStreamVideo({ muted, onStatusChange, streamName, whepUrl }: GameStreamVideoProps) {
  const videoRef = useGameStreamPlayer({
    onStatusChange,
    streamName,
    streamMuted: muted,
    whepUrl,
  });

  return (
    <div className="min-w-screen min-h-screen bg-black">
      <video
        className="min-w-screen min-h-screen bg-black game-stream-video"
        ref={videoRef}
        controls={false}
        controlsList="nodownload nofullscreen noremoteplayback noplaybackrate"
        autoPlay
        muted={muted}
        playsInline
        disablePictureInPicture
        disableRemotePlayback
        tabIndex={-1}
        onContextMenu={event => event.preventDefault()}
        onDoubleClick={event => event.preventDefault()}
        style={{ pointerEvents: 'none' }}
      />
    </div>
  );
}
